import React from 'react';
import DisplayConfiguration from './DisplayConfiguration';
import { pickDataAttributes } from '../../../Util';

const styles = Object.freeze([{},{}]);

const Display260Flex = (props) => {
  const dataAttributes = pickDataAttributes(props, 'display-260-flex');
  
  return <DisplayConfiguration {...props} styles={styles} {...dataAttributes} className="display-260-flex" />;
}
export default Display260Flex;
